<template>
  <div class="Speciallist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        优惠券列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px ;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search" :gutter="10">
          <el-col :span="4">
            <div class="label">优惠券名称:</div>
          </el-col>
          <el-col :span="6">
            <el-input v-model="special" clearable size="small" placeholder="输入优惠券名称"></el-input>
          </el-col>
          <el-col :span="4">
            <div class="label">优惠券类型:</div>
          </el-col>
          <el-col :span="6">
            <template>
              <el-select clearable v-model="value" size="small" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-col>

          <el-col :span="14" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <router-link to="./c_addSpecial" tag="div" class="center_list_head_rig">添加优惠券</router-link>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="id" width="120" label="编号" align="center"></el-table-column>
        <el-table-column prop="name" width="130" label="优惠券名称" align="center"></el-table-column>
        <el-table-column prop="type" width="100" label="优惠券类型" align="center"></el-table-column>
        <!-- <el-table-column prop="create_date" width="170" label="可使用商品" align="center"></el-table-column> -->
        <el-table-column prop="sill" label="使用门槛" align="center"></el-table-column>
        <el-table-column prop="money" label="优惠金额" align="center"></el-table-column>
        <el-table-column prop="end_date1" width="160" label="过期时间" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center"></el-table-column>
        <!-- @change="status($event,scope.row.id)" -->

        <el-table-column label="操作" width="200" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="red(scope.row.id)" class="button1">查看</button>
            <button class="button1">编辑</button>
            <button class="button1" @click="del(scope.row.id)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <!-- <el-col :span="2" style="padding-left:10px;">
            <el-checkbox v-model="selectAll" style="line-height: 34px">全选</el-checkbox>
          </el-col>-->
          <el-col :span="8"></el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加用户 -->
    <el-dialog title="添加账户" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="用户账号:">
          <el-input style="width:356px" v-model="odd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="输入密码:">
          <el-input style="width:356px" type="password" v-model="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:">
          <el-input style="width:356px" type="password" v-model="password1" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  //   name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      options: [
        {
          label: "通用",
          value: 0
        },
        {
          label: "部分分类",
          value: 1
        },
        {
          label: "部分商品",
          value: 2
        },
        {
          label: "部分品牌",
          value: 3
        }
      ],
      value: "",
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      special: "",

      mobile: "",
      create_time: "",
      nickname: "",
      odd: "",
      password: "",
      password1: "",

      value2: true,
      dialogFormVisible1: false,
      id: "",
      mobile: "",
      number: "",
      name: "",
      value1: "",
      resType: null,
      name: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      tableData: [],
      multipleSelection: [],
      isIndeterminate: true,
      select: false,
      selectAll: false,
      checked: [],
      idString: ""
    };
  },
  created() {
    this.$store.state.leftTitle = "优惠券表";
    this.$store.state.topActiveId = 5;
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delete_coupons", {
              params: {
                username: this.username,
                token: this.token,
                coupons_id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.geting(this.page);
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg); 
              } 
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    shipments(id) {
      //确认发货弹窗

      const _this = this;
      this.axios
        .get(this.serve + "/admin/express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },
    submit(id) {
      //弹窗提交

      for (var key in this.tableData) {
        if (this.odd === this.tableData[key].mobile) {
          this.$message.error("此账号已存在");
          return;
        }
      }
      if (this.odd == "") {
        this.$message.error("请输入用户账号");
        return;
      } else if (this.odd !== "") {
        var cel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!cel.test(this.odd)) {
          this.$message.error("账号为手机号码");
          return;
        }
      }
      if (this.password == "") {
        this.$message.error("请输入密码");
        return;
      } else if (this.password !== "") {
        var pass = /^[A-Za-z0-9]{6,20}$/;
        if (!pass.test(this.password)) {
          this.$message.error("登陆密码最小为6位数，最大为20位数");
          return;
        }
      }
      if (this.password1 != this.password) {
        this.$message.error("两次输入密码不一致");

        return;
      }
      if (this.odd || this.password || this.password1) {
        this.dialogFormVisible1 = false;
      }
      const _this = this;

      this.axios
        .get(this.serve + "/admin/create_home_user", {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.odd,
            password: this.password,
            new_pass: this.password1
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.open();
            _this.geting();
          } else if (res.data.status == "error") {
            _this.open4();
          }
        });
    },
    red(id) {
      this.$router.push({
        path: "c_specialLook/" + id
      });
    },

    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },

    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/coupons_list", {
          params: {
            token: this.token,
            username: this.username,
            page: page,
            name: this.special,
            type: this.value
          }
        })
        .then(res => {
          that.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            if (json) {
              that.total = res.data.data.total;
              that.page = res.data.data.page;
              for (var key in json.results) {
                var time = json.results[key].create_date;
                var timeNew = new Date(parseInt(time) * 1000)
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
                json.results[key].end_date1 = timeNew;
                var timeStamp = Date.parse(new Date()) / 1000;

                if (json.results[key].end_date > timeStamp) {
                  json.results[key].status = "未过期";
                } else {
                  json.results[key].status = "已过期";
                }
                if (json.results[key].type == 0) {
                  json.results[key].type = "通用优惠券";
                }
                if (json.results[key].type == 1) {
                  json.results[key].type = "部分分类";
                }
                if (json.results[key].type == 2) {
                  json.results[key].type = "部分商品";
                }
                if (json.results[key].type == 3) {
                  json.results[key].type = "部分品牌";
                }
                that.tableData.push(json.results[key]);
              }
            }
          } else {
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.Speciallist {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>